/* Keep the drawer and cart page in sync after every successful cart mutation. */
(function ($) {
  'use strict';

  theme.updateShippingThreshold = function (cart) {
    $('.spendFreeShip').each(function () {
      var $threshold = $(this);
      var $bar = $threshold.find('.progress-bar');
      var limit = Number($bar.attr('aria-valuemax'));
      if (!Number.isFinite(limit) || limit <= 0) return;

      var total = Math.max(0, Number(cart.total_price) || 0);
      var remaining = Math.max(0, limit - total);
      var value = Math.min(total, limit);
      $bar.attr('aria-valuenow', value).css('width', value / limit * 100 + '%');
      $threshold.find('.text_progress .add_more_price').html(
        theme.function.threshold_cart.replace('#more', theme.Currency.formatMoney(remaining, theme.moneyFormat))
      );
      $threshold.toggleClass('congratulations', remaining === 0);
    });
  };
})(jQuery);
